import { render, staticRenderFns } from "./ChangeRouteOrigin.vue?vue&type=template&id=1d56e42a&scoped=true"
import script from "./ChangeRouteOrigin.vue?vue&type=script&lang=js"
export * from "./ChangeRouteOrigin.vue?vue&type=script&lang=js"
import style0 from "./ChangeRouteOrigin.vue?vue&type=style&index=0&id=1d56e42a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d56e42a",
  null
  
)

export default component.exports